import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import { anonymousService } from '../../../api';
import { PaginatedRequest } from '../../../types/api';

export const fetchEarlySignupUsers = createAsyncThunk('anonymous/fetch-all', (data: PaginatedRequest) =>
  anonymousService.fetchEarlySignupUsers(data),
);
export const cleanAnonymous = createAction('anonymous/clean');
